import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  tabindex: -1,
  class: "form-container"
}
const _hoisted_2 = {
  key: 1,
  tabindex: -1,
  class: "form-container"
}

import { ref, reactive } from "vue";
import { TelegramClient } from "@/websocket/Client";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddTelegramAccountModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const currentStep = ref(1);
const resultLog = ref("");

const formState = reactive({
  phoneNumber: "",
  password: "",
  verificationCode: "",
});

// 添加手机号验证函数
const validatePhone = async (_rule: any, value: string) => {
  if (!value || value.trim() === '') {
    throw new Error('请输入手机号码');
  }
};

// 发送验证码
const handleSendCode = async () => {
  try {
    // 验证手机号
    if (!formState.phoneNumber || formState.phoneNumber.trim() === '') {
      const timestamp = new Date().toLocaleTimeString();
      resultLog.value += `[${timestamp}] 错误: 请输入有效的手机号码\n`;
      return;
    }

    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }
    const client = TelegramClient.getInstance();
    // 这里需要调用相应的WebSocket方法发送手机号
    const res = await client.sendPhoneNumber(username, formState.phoneNumber);
    const timestamp = new Date().toLocaleTimeString();
    resultLog.value = `[${timestamp}] 已发送验证码到手机: ${formState.phoneNumber}\n`;
    resultLog.value += `${JSON.stringify(res)}\n`;
    currentStep.value = 2;
  } catch (error) {
    const timestamp = new Date().toLocaleTimeString();
    resultLog.value += `[${timestamp}] 发送验证码失败: ${error}\n`;
  }
};

// 确认验证码
const handleConfirm = async () => {
  try {
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }

    const client = TelegramClient.getInstance();
    // 这里需要调用相应的WebSocket方法验证验证码
    const res = await client.confirmVerificationCode(
      username,
      formState.phoneNumber,
      formState.password,
      formState.verificationCode
    );

    const timestamp = new Date().toLocaleTimeString();
    resultLog.value += `[${timestamp}] 验证中...\n`;
    resultLog.value += `${JSON.stringify(res)}\n`;

    // 只有当服务器返回成功状态时才触发success事件并关闭窗口
    if (res.nCode === 1) {  // 根据实际API响应结构调整判断条件
      resultLog.value += `[${timestamp}] 验证成功，账号已添加\n`;
      emit("success");
      resetAndClose();
    } else {
      resultLog.value += `[${timestamp}] 验证失败: ${res.strResult}\n`;  // 假设错误信息在res.message中
    }
  } catch (error) {
    const timestamp = new Date().toLocaleTimeString();
    resultLog.value += `[${timestamp}] 验证失败: ${error}\n`;
  }
};

// 添加关闭前的焦点处理
const handleBeforeClose = () => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
};

// 修改取消操作
const handleCancel = () => {
  handleBeforeClose();
  resetAndClose();
};

// 修改重置并关闭弹窗
const resetAndClose = () => {
  handleBeforeClose();
  currentStep.value = 1;
  formState.phoneNumber = "";
  formState.password = "";
  formState.verificationCode = "";
  resultLog.value = "";
  emit("update:visible", false);
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    maskClosable: false,
    title: 
      currentStep.value === 1 ? '添加账号 - 输入手机号' : '添加账号 - 验证码确认'
    ,
    onCancel: handleCancel,
    footer: null,
    width: "500px",
    focusTriggerAfterClose: false,
    autofocus: false,
    destroyOnClose: true,
    "wrap-style": { overflow: 'hidden' }
  }, {
    default: _withCtx(() => [
      (currentStep.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_form, {
              model: formState,
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: "手机号码",
                  rules: [{ required: true, validator: validatePhone }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.phoneNumber,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.phoneNumber) = $event)),
                      placeholder: "请输入手机号码"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: handleSendCode
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" 发送验证码 ")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_a_form, {
              model: formState,
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "验证码" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.verificationCode,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.verificationCode) = $event)),
                      placeholder: "请输入验证码"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "二次验证密码" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.password,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.password) = $event)),
                      placeholder: "如果开启了二次验证，请输入密码"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (currentStep.value = 1))
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("上一步")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: handleConfirm
                        }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode(" 确认添加 ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])),
      _createVNode(_component_a_divider),
      _createVNode(_component_a_textarea, {
        value: resultLog.value,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((resultLog).value = $event)),
        rows: 4,
        readonly: "",
        "auto-size": { minRows: 4, maxRows: 6 }
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})